module.exports = __webpack_public_path__ + "static/img/d2.d792eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/precision/d2.png
// module id = 2u9S
// module chunks = 0